var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react';
import { UitkCard } from 'uitk-react-cards';
import { UitkHeading, UitkText } from 'uitk-react-text';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { BannerMedia } from './banner-media';
import { mapMessagingCardMediaProps } from './activity-message-banner-helper';
export var MessageBanner = function (_a) {
  var headerText = _a.headerText,
    bodyText = _a.bodyText,
    className = _a.className,
    icon = _a.icon,
    mark = _a.mark;
  return React.createElement("aside", {
    className: className,
    "data-testid": "message-banner"
  }, React.createElement(UitkCard, __assign({}, mapMessagingCardMediaProps(icon, mark), {
    padded: true,
    border: true
  }), React.createElement(UitkLayoutFlex, {
    alignItems: "center",
    space: "four"
  }, React.createElement(UitkLayoutFlexItem, null, React.createElement(BannerMedia, {
    icon: icon,
    mark: mark
  })), React.createElement(UitkLayoutFlexItem, null, React.createElement("div", {
    "data-testid": "message-banner-primary-text"
  }, React.createElement(React.Fragment, null, headerText && React.createElement(UitkHeading, {
    tag: "h3",
    size: 7
  }, headerText), bodyText && React.createElement(UitkText, {
    size: 300,
    "data-testid": "message-banner-secondary-text"
  }, bodyText)))))));
};